export default "__VITE_ASSET__CDfkEDUG__"